import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c30158e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-title types" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_6 = {
  key: 1,
  class: "page-title"
}
const _hoisted_7 = {
  key: 2,
  class: "type1"
}
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "option" }
const _hoisted_12 = { class: "option" }
const _hoisted_13 = { class: "desc-c" }
const _hoisted_14 = { class: "desc line3" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "found"
}
const _hoisted_18 = { class: "btns" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang" }, null, -1))
const _hoisted_22 = {
  key: 3,
  class: "type2"
}
const _hoisted_23 = { class: "tr head" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 4,
  class: "type3"
}
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "info" }
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "desc-c" }
const _hoisted_31 = { class: "desc line4" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "movies" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "popup" }
const _hoisted_38 = {
  key: 5,
  class: "type-channel"
}
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { class: "info" }
const _hoisted_41 = { class: "name" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "desc-c" }
const _hoisted_44 = { class: "desc line4" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 6,
  class: "type-short"
}
const _hoisted_48 = {
  key: 7,
  class: "channel_yuedu_article"
}

import movieSearch, { State } from '@/store/channels/search';
import Avatar from '@/views/components/Avatar.vue';
import MoreText from '@/views/components/MoreText.vue';
import Pagination from '@/views/components/Pagination.vue';
import Poster from '@/views/components/Poster.vue';
import * as links from '@/views/links';
import ViewContext from '@/views/ViewContext';
import { computed, inject, onBeforeUnmount, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Album from '@/views/routes/movies/albums/Album.vue';
import i18, { State as I18State } from '@/store/i18';
import ShortItem from '../ShortItem.vue';
import ArticleItem from '../ArticleItem.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const context = inject('context') as ViewContext;
const store = useStore();
const data = computed<State>(() => store.state[movieSearch.name])
const list = computed(() => data.value.albums.slice(0, data.value.pageSize))
const container = ref<HTMLDivElement>()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const state = reactive({
    moreVisible: false,
    moreContent: '',
})
onBeforeUnmount(() => {
    window.onresize = null
    movieSearch.clearSearch(store);
})

function onPageChange(page: number) {
    const query = Object.assign({ kw: data.value.keywords }, { page: page, type: data.value.type, })
    context.go(query)
}

function onType(value: string) {
    const query = Object.assign({ kw: data.value.keywords }, { type: value, page: data.value.page })
    context.go(query)
}

function searchText(value: string) {
    value = value.replace(/<.+?>/g, '')
    return value.replace(new RegExp('(' + data.value.keywords + ')', 'g'), '<label class="kw">$1</label>')
}
function onMovie(item: any) {
    router.push({
        name: 'channel-movies',
        params: {
            id: item.movid
        }
    })
}
function onVideo1(item: any) {
    if (item.video) {
        router.push({
            name: 'channel-movie-player',
            params: {
                id: item.movid,
                url: item.video.urlid
            }
        })
    }
}
function onVideo2(item: any) {
    router.push(links.player(item.movid, item.urlid))
}
function onAuthor(item: any) {
    router.push(links.author(item.id))
}
function onShowMore(value: string) {
    state.moreContent = value
    state.moreVisible = true
}

function onChannel(item: any) {
    router.push({
        name: 'channel-detail',
        params: {
            id: item.id
        }
    })
}

function onArticle(id: number) {
    router.push(`/channels/articles/${id}.html`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onType('channel')))
      }, _toDisplayString(_unref(lang).movieText.search_channel), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel_movie' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onType('channel_movie')))
      }, _toDisplayString(_unref(lang).movieText.search_album), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel_media' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onType('channel_media')))
      }, _toDisplayString(_unref(lang).movieText.search_video), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel_speaker' }),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onType('channel_speaker')))
      }, _toDisplayString(_unref(lang).movieText.search_author), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel_short_video' }),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onType('channel_short_video')))
      }, _toDisplayString(_unref(lang).movieText.search_short), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == 'channel_yuedu_article' }),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onType('channel_yuedu_article')))
      }, _toDisplayString(_unref(lang).movieText.search_article), 3)
    ]),
    (_unref(data).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(lang).movieText.search_loading), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(lang).movieText.search_notfound), 1))
            : _createCommentVNode("", true),
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.search_recommend), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel_movie' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(Poster, {
                      class: "poster",
                      url: item.thumb
                    }, null, 8, ["url"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: searchText(item.title)
                      }, null, 8, _hoisted_10),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(item.language) + " | " + _toDisplayString(item.source), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(lang).movieText.search_album_author) + "： " + _toDisplayString(item.speaker), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_intro) + "： ", 1),
                          _createElementVNode("span", {
                            innerHTML: searchText(item.content)
                          }, null, 8, _hoisted_15),
                          _createElementVNode("a", {
                            class: "more",
                            onClick: ($event: any) => (onShowMore(item.content))
                          }, _toDisplayString(_unref(lang).movieText.search_more), 9, _hoisted_16)
                        ])
                      ]),
                      (item.video)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_found) + "：", 1),
                            _createElementVNode("label", null, _toDisplayString(item.video.seo_title), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("a", {
                          class: "detail",
                          onClick: ($event: any) => (onMovie(item))
                        }, _toDisplayString(_unref(lang).movieText.search_album_detail), 9, _hoisted_19),
                        (item.video)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "play",
                              onClick: ($event: any) => (onVideo1(item))
                            }, [
                              _hoisted_21,
                              _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_play), 1)
                            ], 8, _hoisted_20))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel_media' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_no), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_title), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_album), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_author), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "tr",
                    onClick: ($event: any) => (onVideo2(item))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(data).page * _unref(data).pageSize + i + 1), 1),
                    _createElementVNode("span", {
                      innerHTML: searchText(item.seo_title || item.title)
                    }, null, 8, _hoisted_25),
                    _createElementVNode("span", null, _toDisplayString(item.movie_title), 1),
                    _createElementVNode("span", null, _toDisplayString(item.movie_speaker), 1)
                  ], 8, _hoisted_24))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel_speaker' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(Avatar, {
                      url: item.thumb
                    }, null, 8, ["url"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", {
                            innerHTML: searchText(item.content)
                          }, null, 8, _hoisted_32),
                          _createElementVNode("a", {
                            class: "more",
                            onClick: ($event: any) => (onShowMore(item.content))
                          }, _toDisplayString(_unref(lang).movieText.search_more), 9, _hoisted_33)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("a", {
                          class: "all",
                          onClick: ($event: any) => (onAuthor(item))
                        }, _toDisplayString(_unref(lang).movieText.search_author_detail), 9, _hoisted_35),
                        (item.items)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.items.slice(0, 5), (movie) => {
                              return (_openBlock(), _createElementBlock("a", {
                                class: "movie-item",
                                onClick: ($event: any) => (onMovie(movie))
                              }, [
                                _createVNode(Poster, {
                                  url: movie.thumb
                                }, null, 8, ["url"]),
                                _createElementVNode("div", _hoisted_37, _toDisplayString(movie.title), 1)
                              ], 8, _hoisted_36))
                            }), 256))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(Avatar, {
                      url: item.thumb,
                      onClick: ($event: any) => (onChannel(item))
                    }, null, 8, ["url", "onClick"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (onChannel(item))
                        }, _toDisplayString(item.title), 9, _hoisted_42)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", {
                            innerHTML: searchText(item.intro)
                          }, null, 8, _hoisted_45),
                          _createElementVNode("a", {
                            class: "more",
                            onClick: ($event: any) => (onShowMore(item.intro))
                          }, _toDisplayString(_unref(lang).movieText.search_more), 9, _hoisted_46)
                        ])
                      ])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel_short_video' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item) => {
                  return (_openBlock(), _createBlock(ShortItem, { item: item }, null, 8, ["item"]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 'channel_yuedu_article' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item) => {
                  return (_openBlock(), _createBlock(ArticleItem, {
                    item: item,
                    onClick: ($event: any) => (onArticle(item.id))
                  }, null, 8, ["item", "onClick"]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 8,
                class: "albums",
                ref_key: "container",
                ref: container
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
                  return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
                }), 256))
              ], 512))
            : _createCommentVNode("", true),
          _createVNode(Pagination, {
            total: _unref(data).total,
            page: _unref(data).page,
            size: _unref(data).pageSize,
            onChange: onPageChange
          }, null, 8, ["total", "page", "size"])
        ])),
    (_unref(state).moreVisible)
      ? (_openBlock(), _createBlock(MoreText, {
          key: 2,
          content: _unref(state).moreContent,
          theme: "light",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).moreVisible = false))
        }, null, 8, ["content"]))
      : _createCommentVNode("", true)
  ]))
}
}

})